<template>
  <div class="need-box">
    <!-- Text box to update the need -->
    <v-textarea
      ref="needInput"
      v-model="newNeed"
      class="custom-textarea"
      label="Write the current need or pain"
      rows="5"
      outlined
    ></v-textarea>

    <!-- Action buttons -->
    <div class="button-group">
      <v-btn color="primary" @click="updateNeed" class="apply-btn">
        <v-icon left>mdi-check</v-icon>
        Save
      </v-btn>
      <v-btn variant="text" @click="cancelEdit" class="cancel-btn">
        <v-icon left>mdi-close</v-icon>
        Cancel
      </v-btn>
    </div>
  </div>
</template>

<script>
import apiClient from "@/plugins/apiService";

export default {
  props: ["selectedProblem", "need"],
  emits: ["needUpdated", "cancel"],
  data() {
    return {
      newNeed: "",
      originalNeed: "",
    };
  },
  watch: {
    need(newVal) {
      this.newNeed = newVal || "";
      this.originalNeed = newVal || "";
    },
  },
  mounted() {
    this.newNeed = this.need || "";
    this.originalNeed = this.need || "";
  },
  methods: {
    focusInput() {
      this.$refs.needInput?.focus();
    },
    async updateNeed() {
      if (this.selectedProblem) {
        try {
          const response = await apiClient.put(
            `/update_need/${this.selectedProblem}`,
            { need: this.newNeed }
          );
          if (response.status === 200) {
            this.snackbar = true;
            this.$emit("needUpdated", this.newNeed);
          } else {
            console.error("Error updating need:", response.data.error);
          }
        } catch (error) {
          console.error("Error updating need:", error);
        }
      } else {
        console.warn("No problem selected");
      }
    },
    cancelEdit() {
      this.newNeed = this.originalNeed;
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.custom-textarea {
  font-family: inherit;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
